import { UserFieldErrorMessages } from "@constants/Errors";
import { handleNumericalCheck } from "@services/ErrorHandling";

type UserDepartmentPositionCardProps = {
  departmentName: string;
  positionName: string;
  errors: any;
  updateTenantDepartmentData: (field: string, value: any) => void;
  updateError: (field: string, value: any) => void;
  handleDepartmentClick: () => void;
};

export const UserDepartmentPositionCard = ({
  departmentName,
  positionName,
  errors,
  updateTenantDepartmentData,
  updateError,
  handleDepartmentClick,
}: UserDepartmentPositionCardProps) => (
  <>
    <div className="flex items-center gap-2.5">
      <input
        type="text"
        className="form-field-text whitespace-nowrap w-1/4"
        value={departmentName || "未登録"}
        readOnly
      />
      <div className="button-default-white" onClick={handleDepartmentClick}>
        部署選択
      </div>
    </div>

    <div className="mt-5 divider"></div>

    <h2 className="mb-5 label-light-blue-xl"> 役職 </h2>

    <input
      type="text"
      className="form-text-field-border"
      value={positionName}
      placeholder="未登録"
      onChange={(e) =>
        handleNumericalCheck(
          "position_name",
          e.target.value,
          updateTenantDepartmentData,
          updateError,
        )
      }
    />
    {errors.position_name && (
      <p className="text-red-500">{UserFieldErrorMessages.positionError}</p>
    )}
    <div className="mt-5 divider"></div>
  </>
);
